
import React, { useEffect, useState } from "react";
import axios from "axios"; 
import { useParams, useNavigate, Link } from "react-router-dom";
import config from '../../config';

function BlogDetails() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [activeLanguage, setActiveLanguage] = useState('en');
    const navigate = useNavigate();

    const fetchBlogDetails = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-blog-admin/${id}`, { withCredentials: true });
            setBlog(response.data);
        } catch (err) {
            setError('Failed to fetch blog details');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchBlogDetails();
    }, [id]);

    const handleDelete = async () => {
        const confirmDelete = window.confirm('Are you sure you want to delete this blog? This action cannot be undone.');
        if (!confirmDelete) return;

        try {
            await axios.delete(`${config.BASE_URL}/api/admin/delete-blog/${id}`, { withCredentials: true });
            navigate('/admin/blogs'); 
        } catch (err) {
            setError('Failed to delete the blog');
        }
    };

    // Language switching
    const switchLanguage = (lang) => {
        setActiveLanguage(lang);
    };

    // Get current language data
    const getCurrentLanguageData = () => {
        if (activeLanguage === 'es' && blog?.spanishData) {
            return {
                title: blog.spanishData.title || 'No Spanish title available',
                description: blog.spanishData.description || 'No Spanish description available',
                // slug: blog.spanishData.slug || '',
                centerContent: blog.spanishData.centerContent || []
            };
        }
        // Default to English
        return {
            title: blog?.title || 'No title available',
            description: blog?.description || 'No description available',
            // slug: blog?.slug || '',
            centerContent: blog?.centerContent || []
        };
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;
    if (!blog) return <p>Blog not found</p>;

    const currentData = getCurrentLanguageData();
    const hasSpanishData = blog.spanishData && (blog.spanishData.title || blog.spanishData.description || (blog.spanishData.centerContent && blog.spanishData.centerContent.length > 0));

    return (
        <div className="dashboard project_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Dashboard</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>
                
                <div className="main-section">
                    <div className="projects">
                        <div className="projects-inner">
                            
                            {/* Language Tabs - Only show if Spanish data exists */}
                            {hasSpanishData && (
                                <div className="language-tabs" style={{ marginBottom: '20px' }}>
                                    <button 
                                        type="button" 
                                        className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                                        onClick={() => switchLanguage('en')}
                                        style={{
                                            padding: '10px 20px',
                                            marginRight: '10px',
                                            backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                                            color: activeLanguage === 'en' ? 'white' : 'black',
                                            border: '1px solid #ddd',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        English
                                    </button>
                                    <button 
                                        type="button" 
                                        className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                                        onClick={() => switchLanguage('es')}
                                        style={{
                                            padding: '10px 20px',
                                            backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                                            color: activeLanguage === 'es' ? 'white' : 'black',
                                            border: '1px solid #ddd',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Spanish
                                    </button>
                                </div>
                            )}

                            {/* Current Language Indicator */}
                            <div style={{ marginBottom: '15px' }}>
                                <span style={{ 
                                    fontSize: '14px', 
                                    color: '#666',
                                    fontWeight: 'bold' 
                                }}>
                                    Viewing: {activeLanguage === 'en' ? 'English' : 'Spanish'} Content
                                </span>
                            </div>

                            {/* Title */}
                            <div className="detail_item">
                                <h2>Title</h2>
                                <div className="detail_item_inner">
                                    <p>{currentData.title}</p>
                                </div>
                            </div>

                            {/* Slug */}
                            {/* {currentData.slug && (
                                <div className="detail_item">
                                    <h2>Slug</h2>
                                    <div className="detail_item_inner">
                                        <p><code>{currentData.slug}</code></p>
                                    </div>
                                </div>
                            )} */}

                            {/* Description */}
                            {currentData.description && (
                                <div className="detail_item">
                                    <h2>Description</h2>
                                    <div className="detail_item_inner">
                                        <div dangerouslySetInnerHTML={{ __html: currentData.description }} />
                                    </div>
                                </div>
                            )}

                            {/* Featured Image - Shared across languages */}
                            <div className="detail_item">
                                <div className="detail_banner_wrap">
                                    <div className="detail_img_grid">
                                        {blog.featuredImage ? (
                                            <div className="detail_img_item">
                                                <h2>Featured Image</h2>
                                                <div className="banner_img_wrap">
                                                    <img src={`${config.BASE_URL}${blog.featuredImage}`} alt="Featured" />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="detail_img_item">
                                                <h2>Featured Image</h2>
                                                <p>No image available.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Center Content Sections */}
                            {currentData.centerContent && currentData.centerContent.length > 0 && (
                                <div className="add_field textareaField repeaterFields">
                                    <h2><b>Content Sections</b></h2>
                                    {currentData.centerContent.map((field, index) => (
                                        <div key={index} className="singleReapterFieldContent update displayContent">
                                            {/* Section Title */}
                                            {field.title && (
                                                <div className="detail_item">
                                                    <h3>Section {index + 1} - {field.title}</h3>
                                                </div>
                                            )}
                                            
                                            {/* Section Description */}
                                            <div className="detail_item">
                                                <h3>Section {index + 1} Content</h3>
                                                <div className="detail_item_inner">
                                                    <div dangerouslySetInnerHTML={{ __html: field?.description || 'No content available' }} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Gallery Images - Shared across languages */}
                            <div className="detail_item">
                                <h2>Gallery Images</h2>
                                <div className="detail_item_inner gallery_inner">
                                    <div className="detail_img_grid">
                                        {blog.galleryImages && blog.galleryImages.length > 0 ? (
                                            blog.galleryImages.map((image, index) => (
                                                <div className="detail_img_item" key={index}>
                                                    <img src={`${config.BASE_URL}${image}`} alt={`Blog image ${index}`} />
                                                </div>
                                            ))
                                        ) : (
                                            <p>No images available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Blog Metadata */}
                            <div className="detail_item">
                                <h2>Blog Information</h2>
                                <div className="detail_item_inner">
                                    <p><strong>Primary Language:</strong> {blog.language || 'en'}</p>
                                    <p><strong>Has Spanish Translation:</strong> {hasSpanishData ? 'Yes' : 'No'}</p>
                                    {blog.created_at && (
                                        <p><strong>Created:</strong> {new Date(blog.created_at).toLocaleDateString()}</p>
                                    )}
                                    {blog.updated_at && (
                                        <p><strong>Last Updated:</strong> {new Date(blog.updated_at).toLocaleDateString()}</p>
                                    )}
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="detail_project_btn_wrap">
                                <div className="detail_edit_del">
                                    <div className="btn_item">
                                        <button 
                                            className="detail_btns" 
                                            onClick={handleDelete}
                                            style={{ backgroundColor: '#dc3545' }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                    <div className="btn_item">
                                        <Link 
                                            to={`/admin/update-blog/${blog._id}`} 
                                            className="update_detail detail_btns"
                                        >
                                            Edit
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BlogDetails;
